import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import { IpValidator } from './ip.validator';

export const HostnameValidator: (errorMessage: string, allowPort?: boolean, allowPath?: boolean) => FormValidator = (
  errorMessage: string,
  allowPort: boolean = true,
  allowPath: boolean = false
) => {
  return async (value: string): Promise<ValidationResult> => {
    // check if value is an IP
    const ipValidationResult: ValidationResult = await IpValidator(errorMessage, true, false)(value);
    if (ipValidationResult.valid) {
      return ipValidationResult;
    }

    // check first character
    if (value[0] === '.' || value[0] === '_' || value[0] === '-') {
      return { valid: false, error: errorMessage };
    }

    // check regex
    const hostnameRegex = allowPath ? /^([a-zA-Z0-9-._~%/])+$/i : /^([a-zA-Z0-9-._~%])+$/i;
    if (hostnameRegex.test(value)) {
      return { valid: true };
    }

    // check for port
    if (allowPort) {
      const hostnamePortRegex = allowPath
        ? /^([a-zA-Z0-9-._~%]+)(:(\d+))?([a-zA-Z0-9-._~%/]+)$/
        : /^([a-zA-Z0-9-._~%]+)(:(\d+))?$/;
      if (hostnamePortRegex.test(value)) {
        return { valid: true };
      }
    }

    return { valid: false, error: errorMessage };
  };
};
